// extracted by mini-css-extract-plugin
export default {"stage":"stage-8ce8","piece":"piece-2641","burst":"burst-fe15"};